// extracted by mini-css-extract-plugin
export default {"op":"PieSlice_op__XTWf-","hovered":"PieSlice_hovered__7VX3V","notHovered":"PieSlice_notHovered__hX1vm","slice":"PieSlice_slice__Ny8Gv","label":"PieSlice_label__xhzSr"};